import { useToast } from "@chakra-ui/react";
import { APIError } from "common";
import { useEffect } from "react";

export const useToastOnAPIError = ({
  error,
  title,
}: {
  title: string;
  error: APIError | undefined;
}) => {
  const toast = useToast();
  useEffect(() => {
    if (error !== undefined) {
      toast({
        position: "top",
        status: "error",
        title,
        description: error.getMessage(),
      });
    }
  }, [error, title, toast]);
};
